import { render, staticRenderFns } from "./billManage.vue?vue&type=template&id=32a151ce&scoped=true&"
import script from "./billManage.vue?vue&type=script&lang=js&"
export * from "./billManage.vue?vue&type=script&lang=js&"
import style0 from "./billManage.vue?vue&type=style&index=0&id=32a151ce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a151ce",
  null
  
)

export default component.exports